const setHouseSection1 = (payload) => {
  return {
    type: "setHouseSection1",
    payload,
  };
};
export default setHouseSection1;
